<template>
    <div class="changePwd">
        <div class="wrap">
            <div class="title_wrap">
                <span class="title_name">修改密码</span>
            </div>
            <div class="email">
                <input type="password" placeholder="新密码" v-model="newPwd">
            </div>
            <div class="email">
                <input type="password" placeholder="确认密码" v-model="re_newPwd">
            </div>
            <div class="next">
                <input type="button" value="确认修改" @click="next">
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data () {
        return {
            email: '',
            newPwd: '',
            re_newPwd: ''
        }
    },
    mounted: function () {
        if(this.$ls.get('token')==undefined){
            this.$router.push('/login')
        }
        this.username = this.$route.params.username
        this.email = this.$route.params.email
    },
    methods: {
        next: function () {
            let _t = this
            if(_t.newPwd === "" || _t.re_newPwd === ""){
                return _t.$messagewarning("请输入新密码")
            }
            if(_t.newPwd === _t.re_newPwd){
                axios.post('/api/user/updatePwd',{token:this.$ls.get('token'), newPwd: _t.re_newPwd, username: _t.username, email: _t.email})
                .then(function (resp) {
                    if(resp.data.code === '0'){
                        _t.$messagesuccess(resp.data.msg)
                        _t.$ls.remove("token");
                        _t.$ls.remove("role");
                        _t.$router.push('/login')
                    }else{
                         _t.$messagewarning(resp.data.msg)
                    }
                })
                .catch(function (err) {
                    console.log(err)
                })
            }else{
                return _t.$messagewarning("两次密码输入不一致")
            }
        }
    }
}
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

    .wrap{
        width: 900px;
        margin: 56px auto 300px;
    }
    .title_wrap{
        border-bottom: 1px solid #a3a3a3;
        margin-bottom: 25px;
        text-align: left;
        position: relative;
    }
    .title_name{
        font-family: sy;
        border-bottom: 4px solid $color-dark-blue;
        color: black;
        font-weight:600;
        font-size: 20px;
    } 
    .email>input{
        height: 40px;
        font-size: 17px;
        width: 100%;
        background-color: #eee;
        padding-left: 16px;
        margin-bottom: 20px;
    }
    .next>input{
        border-radius: 2px;
        background: $color-dark-blue;
        height: 40px;
        line-height: 40px;
        color: #fff;
        font-family: sy;
        width: 300px;
        cursor: pointer;
        font-size: 17px;
    }
    .next{
        text-align: center;
        margin-top: 40px;
    }

</style>



// WEBPACK FOOTER //
// UserChangePwd.vue?c3d81f44